export function genderFilter(value) {
  const genderMap = {
    female: '小姐',
    male: '先生',
  }
  return genderMap[value]
}
export const productTypeList = {
  activity: {
    name: '活動',
    icon: 'icons',
  },
  course: {
    name: '課程',
    icon: 'graduation-cap',
  },
  service: {
    name: '服務',
    icon: 'hand-receiving',
  },
  reservation: {
    name: '餐飲訂位',
    icon: 'utensils',
  },
  guide: {
    name: '導覽',
    icon: 'headset',
  },
  light: {
    name: '點燈',
    image: 'light',
  },
  treasury: {
    name: '補庫',
    image: 'treasury',
  },
  puja: {
    name: '法會',
    image: 'puja',
  },
  pudu: {
    name: '贊普',
    image: 'pudu',
  },
  worshipset: {
    name: '斗燈',
    image: 'worshipset',
  },
}

export function productTypeFilter(value) {
  return productTypeList[value].name
}
export const productStateMap = {
  0: {
    color: 'info',
    text: '未上架',
    buttons: ['edit', 'on', 'orders', 'calendarUrl'],
  },
  1: {
    color: 'success',
    text: '上架中',
    buttons: ['edit', 'off', 'orders', 'calendarUrl'],
  },
  2: {
    color: 'warning',
    text: '新增中',
    buttons: ['add'],
  },
}

export function productStateFilter(value, property) {
  return productStateMap[value][property]
}
export function inventoryCapacityFilter(soldQty, inventory, infinity) {
  if (infinity) return `${soldQty} / 無限`
  const noInventory = soldQty === 0 && inventory === 0
  const eventIsFull = soldQty >= inventory

  return noInventory ? '未設定庫存' : eventIsFull ? '已額滿' : `${soldQty} / ${inventory}`
}
export function inventoryRepeatFilter(type, withArray) {
  const repeatTypeMap = {
    day: '每天',
    week: `每週的${repeatWithWeek(withArray)}`,
    lunarMonth: `每月的${repeatWithMonth(withArray)}`,
  }
  return repeatTypeMap[type] || '不重複'
}
export const daysInWeek = ['日', '一', '二', '三', '四', '五', '六']
export const lunarDays = [
  { name: '初一', value: 1 },
  { name: '初二', value: 2 },
  { name: '初三', value: 3 },
  { name: '初四', value: 4 },
  { name: '初五', value: 5 },
  { name: '初六', value: 6 },
  { name: '初七', value: 7 },
  { name: '初八', value: 8 },
  { name: '初九', value: 9 },
  { name: '初十', value: 10 },
  { name: '十一', value: 11 },
  { name: '十二', value: 12 },
  { name: '十三', value: 13 },
  { name: '十四', value: 14 },
  { name: '十五', value: 15 },
  { name: '十六', value: 16 },
  { name: '十七', value: 17 },
  { name: '十八', value: 18 },
  { name: '十九', value: 19 },
  { name: '二十', value: 20 },
  { name: '廿一', value: 21 },
  { name: '廿二', value: 22 },
  { name: '廿三', value: 23 },
  { name: '廿四', value: 24 },
  { name: '廿五', value: 25 },
  { name: '廿六', value: 26 },
  { name: '廿七', value: 27 },
  { name: '廿八', value: 28 },
  { name: '廿九', value: 29 },
  { name: '三十', value: 30 },
]

function repeatWithWeek(daysArray) {
  // * sort() will effect original array
  const sortedDaysArray = Object.assign([], daysArray)
    .sort()
    .map((day) => daysInWeek[day])

  const numberOfDays = daysArray.length
  return numberOfDays === daysInWeek.length ? '每天' : numberOfDays <= 2 ? sortedDaysArray.join('與') : `${sortedDaysArray.slice(0, -1).join('、')}與${sortedDaysArray.slice(-1)}`
}

function repeatWithMonth(daysArray) {
  // * sort() will effect original array
  const sortedDaysArray = Object.assign([], daysArray)
    .sort((a, b) => a - b)
    .map((day) => {
      if (day > 0) return lunarDays[day - 1].name
    })

  const numberOfDays = daysArray.length
  return numberOfDays === lunarDays.length ? '每天' : sortedDaysArray.join('、')
}

export const orderStatusMap = {
  0: {
    color: 'info',
    text: '已取消',
  },
  1: {
    color: 'success',
    text: '已付款',
  },
  2: {
    color: 'danger',
    text: '未付款',
  },
  3: {
    color: 'warning',
    text: '待處理',
  },
  4: {
    color: 'finish',
    text: '已完成',
  },
}

export const orderStatusBasicMap = {
  0: {
    color: 'info',
    text: '已取消',
  },
  1: {
    color: 'success',
    text: '已付款',
  },
  2: {
    color: 'danger',
    text: '未付款',
  },
}

export function orderStatusFilter(value, property) {
  return orderStatusMap[value][property]
}

export const prepaidOrderStatusMap = {
  0: {
    color: 'info',
    text: '已取消',
  },
  1: {
    color: 'success',
    text: '已抵扣',
  },
  2: {
    color: 'danger',
    text: '待確認',
  },
}

export function prepaidOrderStatusFilter(value, property) {
  return prepaidOrderStatusMap[value][property]
}

export const orderSourceMap = {
  manual: '手動',
  site: '線上',
  line: 'LINE Bot',
  // facebook: 'Facebook',
}

export function orderSourceFilter(value) {
  return orderSourceMap[value]
}
export const orderPaymentMethodMap = {
  Free: '免費',
  Cash: '現金',
  Credit: '信用卡',
  Prepaid: '預付抵扣',
  // Linepay: 'LINE Pay',
  Vacc: '虛擬帳戶',
}

export function orderPaymentMethodFilter(value) {
  return orderPaymentMethodMap[value]
}
export const couponStatusMap = {
  0: {
    color: 'danger',
    text: '未開放',
  },
  1: {
    color: 'success',
    text: '開放中',
  },
}

export function defaultStatusFilter(value, property) {
  return couponStatusMap[value] && couponStatusMap[value][property]
}

export function numberUnitFilter(unit) {
  return unit === 'fixed' ? '元' : unit
}
export const planIntervalMap = {
  month: '月',
  year: '年',
  twoYear: '2年',
}

export function planIntervalFilter(interval, withSlash = true) {
  const intervalText = planIntervalMap[interval]
  return withSlash ? `/${intervalText}` : `${intervalText}付`
}

export function planPriceFilter(price, withSymbol = true) {
  const formatPrice = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return formatPrice === '0' ? '客製化方案' : withSymbol ? `NT$ ${formatPrice}` : formatPrice
}

export function inventoryGroupStatusFilter(value, property) {
  const groupStatusMap = {
    0: {
      color: 'warning',
      text: '全部皆關閉',
    },
    1: {
      color: 'success',
      text: '全部皆開放',
    },
    2: {
      color: 'semi-success-warning',
      text: '部分開放部分關閉',
    },
  }
  return groupStatusMap[value][property]
}

export function prepaidCapacityFilter(infinity = 1, soldQty, inventory) {
  return infinity === 1 ? `${soldQty} / 無上限` : soldQty === inventory ? '已售完' : `${soldQty} / ${inventory}`
}
